// ? Login module routes
import NoLeftSpaceLayout from '../../layouts/NoLeftSpaceLayout.vue';
import PreLogin from './PreLogin.vue';
import PostLogin from './postLogin/PostLogin.vue';
import PostLogout from './PostLogout.vue';
import LoginLandingPage from './loginLandingPage/LoginLandingPage.vue';
import { RouteNames } from '@/router/routeNames';
import AppUpdate from './preLogin/appupdate/AppUpdate.vue';
import UnsupportedBrowser from './preLogin/unsupportedbrowser/UnsupportedBrowser.vue';
import MaintenancePage from './preLogin/maintenance/MaintenancePage.vue';
import { preloginNavGuard } from './preloginNavGuard';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw = {
  path: '/login',
  name: RouteNames.LOGIN_SHELL,
  component: NoLeftSpaceLayout,
  children: [
    {
      name: RouteNames.POST_LOGIN,
      path: 'post',
      component: PostLogin,
      meta: {
        pageTitle: 'Landing.PostLogin',
      },
    },
    {
      name: RouteNames.PRE_LOGIN,
      path: 'pre',
      component: PreLogin,
      meta: {
        pageTitle: 'Landing.PreLogin',
      },
      beforeEnter: preloginNavGuard,
      children: [
        {
          name: RouteNames.APP_UPDATE,
          path: 'appupdate',
          component: AppUpdate,
        },
        {
          name: RouteNames.UNSUPPORTED_BROWSER,
          path: 'unsupportedBrowser',
          component: UnsupportedBrowser,
        },
        {
          name: RouteNames.MAINTENANCE_MODE,
          path: 'maintenanceMode',
          component: MaintenancePage,
        },
      ],
    },
    {
      name: RouteNames.POST_LOGOUT,
      path: 'postLogoutPorch',
      component: PostLogout,
    },
    {
      name: RouteNames.LOGIN_LANDING_PAGE,
      path: 'loginLandingPage',
      component: LoginLandingPage,
    },
  ],
};

export default routes;
